module.exports = __webpack_public_path__ + "static/media/referral-banner-mobile.d735fe75.jpg";